import React, { Fragment } from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Star from './assets/star.png'
import Flame from './assets/icon-flame.png'
import IconChef from './assets/icon-chef.png'
import IconDish from './assets/icon-dish.png'
import Alert from './assets/alert-triangle.png'
import MinusWhite from '../../assets/img/minus-black.png'
import PlusWhite from '../../assets/img/plus-white.png'
import PlusBlack from '../../assets/img/plus-black.png'
import InfoIcon from './assets/icon-info.png'

import Like from '../../assets/img/heart.png'
import Dislike from '../../assets/img/slash.png'

import { getCategoryTag } from './utils'

import './MealCard.css'

const MealCard = props => {
  const {
    like,
    compact,
    quantity,
    stars,
    chefImage,
    mealImage,
    mealName,
    mealDescription,
    chefName,
    included,
    extra,
    price,
    onMealClick,
    onChefClick,
    className,
    style,
    isLoading,
    category,
    calories,
    newChef,
    newDish,
    qtyOrdered,
    qtyTotal,
    canEdit,
    removeProduct,
    addProduct,
    warning,
    showWarnings,
    id,
    onLike,
    onDislike,
    showPrice
  } = props

  const categoryTag = !compact && category && getCategoryTag(category)

  const noStock = canEdit && (qtyTotal || 0) <= 0

  if (isLoading) {
    return (
      <div
        className={classnames(
          'cookunity__mealcard_new loading',
          { compact },
          className
        )}
        style={style}>
        <div
          className={classnames('meal_image_container loading', { compact })}>
          <div className="meal_image loading" />
        </div>

        <div className={classnames('bottom_info', { compact })}>
          <div className="meal_name">
            <div className={classnames('title loading', { compact })} />
            <div className={classnames('subtitle loading', { compact })} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={classnames('cookunity__mealcard_new', { compact }, className)}
      style={style}>
      <div className={classnames('top_info', { compact })}>
        <div className="chef_details">
          <div className={classnames('chef_image_container', { compact })}>
            {chefName && (
              <img
                src={chefImage}
                alt="chef"
                className="chef_image"
                onClick={onChefClick}
              />
            )}
          </div>

          <span className="chef_name" onClick={onChefClick}>
            {chefName}
          </span>
        </div>

        {!!stars && (
          <div className="meal_stars_badge">
            <img className="star" src={Star} alt="star" />
            <span className="rating">{Number(stars).toFixed(1)}</span>
          </div>
        )}

        {!!quantity && (
          <div className="meal_count_badge">
            <span className="meal_count">{quantity}</span>
          </div>
        )}
      </div>

      <div className={classnames('meal_image_container', { compact })}>
        {noStock && (
          <div className="out_of_stock">
            <span>Out of stock</span>
            <img src={InfoIcon} alt="info" id={`nostock-${id}`} />
            <UncontrolledTooltip
              trigger="hover click"
              offset="0, 4px"
              placement="top"
              delay={{ show: 0, hide: 2000 }}
              target={`nostock-${id}`}>
              <p style={{ fontFamily: 'Roboto', fontSize: 12, margin: 0 }}>
                The CookUnity kitchen is truly artisanal cooking and real local
                chefs cook in small batches daily
              </p>
            </UncontrolledTooltip>
          </div>
        )}
        <div className="gradient" onClick={onMealClick} />
        <img
          className="meal_image"
          src={mealImage}
          alt="meal"
          onClick={onMealClick}
        />
      </div>

      <div className={classnames('bottom_info', { compact })}>
        <div className="meal_name" onClick={onMealClick}>
          <p className={classnames('title', { compact })}>{mealName}</p>
          <p className={classnames('subtitle', { compact })}>
            {mealDescription}
          </p>
        </div>

        {!compact && (
          <div className="meal_tags">
            {category && categoryTag && (
              <div className="tag">
                <img className="icon" src={categoryTag.icon} alt="tag" />
                <span className="label">{categoryTag.label}</span>
              </div>
            )}

            {calories && (
              <div className="tag">
                <img className="icon" src={Flame} alt="tag" />
                <span className="label">{`${calories} cal`}</span>
              </div>
            )}
          </div>
        )}

        {compact && (included || extra) && (
          <div className="checkout_info">
            {included && <span className="included">Included</span>}
            {extra && <span>{price}</span>}
          </div>
        )}

        {like && (
          <div className="like_buttons">
            <button className="button-like" onClick={onLike}>
              <img src={Like} alt="like" />
            </button>
            <button className="button-like" onClick={onDislike}>
              <img src={Dislike} alt="dislike" />
            </button>
          </div>
        )}

        {canEdit && qtyTotal > 0 && (
          <div
            className={classnames('order_handler', {
              nodesc: !mealDescription
            })}>
            <div className="buttons_container">
              {qtyOrdered > 0 && (
                <Fragment>
                  <button
                    className="button"
                    onClick={() => {
                      if (!(qtyOrdered <= 0)) {
                        removeProduct()
                      }
                    }}
                    disabled={qtyOrdered <= 0}>
                    <img src={MinusWhite} alt="add" />
                  </button>
                  <div className="qty_ordered">
                    <span>{qtyOrdered}</span>
                  </div>
                </Fragment>
              )}
              <button
                className={classnames('button', { black: qtyOrdered === 0 })}
                onClick={() => {
                  if (!(qtyOrdered >= qtyTotal || noStock)) {
                    addProduct()
                  }
                }}
                disabled={qtyOrdered >= qtyTotal || noStock}>
                <img
                  src={
                    qtyOrdered === 0 || qtyOrdered >= qtyTotal || qtyTotal === 0
                      ? PlusWhite
                      : PlusBlack
                  }
                  alt="add"
                />
              </button>
            </div>
            {showPrice && <span className="price">{price}</span>}
          </div>
        )}
      </div>

      {!compact &&
        (newChef ? (
          <div className="meal_badge_container">
            <div className="meal_badge">
              <img className="icon" src={IconChef} alt="chef icon" />
              <span className="label">New chef</span>
            </div>
            <div className="meal_badge_triangle" />
          </div>
        ) : newDish ? (
          <div className="meal_badge_container">
            <div className="meal_badge">
              <img className="icon" src={IconDish} alt="dish icon" />
              <span className="label">New dish</span>
            </div>
            <div className="meal_badge_triangle" />
          </div>
        ) : null)}

      {showWarnings && warning && (
        <Fragment>
          <div className="meal_warning_container">
            <img src={Alert} alt="alert" id={`warning-${id}`} />
            <UncontrolledTooltip
              trigger="hover click"
              offset="0, 4px"
              placement="top"
              delay={{ show: 0, hide: 2000 }}
              target={`warning-${id}`}>
              <span>{warning}</span>
            </UncontrolledTooltip>
          </div>
        </Fragment>
      )}
    </div>
  )
}

MealCard.propTypes = {
  category: PropTypes.oneOf([
    'meat',
    'poultry',
    'seafood',
    'glutenfree',
    'keto',
    'paleo',
    'vegan',
    'vegetarian',
    'whole30'
  ])
}

export default MealCard



// WEBPACK FOOTER //
// ./src/components/MealCard/MealCard.jsx